import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import getStateThemes, {
  ELEMENT_CATEGORIES,
} from 'chameleon/ui-stack/ui/base/theme';

const Tag = forwardRef((props, ref) => {
  const {
    id,
    children,
    className,
    isPrimary,
    isSecondary,
    isAlert,
    background,
    isFullWidth,
    accessibility,
    ...otherProps
  } = props;

  const classes = cn(
    'relative rounded-20 text-14 px-0.8 h-12.2 leading-8 text-ellipsis text-center flex items-center',
    className,
    {
      'w-full': isFullWidth,
      [getStateThemes({
        type: ELEMENT_CATEGORIES.PRIMARY,
        background,
        hasHover: false,
        isButton: false,
      })]: isPrimary,
      [getStateThemes({
        type: ELEMENT_CATEGORIES.SECONDARY,
        background,
        hasHover: false,
        isButton: false,
      })]: isSecondary,
      [getStateThemes({
        type: ELEMENT_CATEGORIES.ALERT,
        background,
        hasHover: false,
        isButton: false,
      })]: isAlert,
    },
  );

  return (
    <div
      ref={ref}
      id={id}
      data-test-id="ui-tag-content"
      className={classes}
      tabIndex={0}
      role="button"
      {...accessibility}
      {...otherProps}
    >
      {children}
    </div>
  );
});

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  isPrimary: PropTypes.bool,
  isSecondary: PropTypes.bool,
  isAlert: PropTypes.bool,
  className: PropTypes.string,
  background: PropTypes.string,
  id: PropTypes.string,
  isFullWidth: PropTypes.bool,
  accessibility: PropTypes.shape({
    title: PropTypes.string,
    'aria-label': PropTypes.string,
    'aria-labelledby': PropTypes.string,
  }),
};

Tag.defaultProps = {
  isPrimary: false,
  isSecondary: false,
  isAlert: false,
  className: '',
  background: '',
  id: null,
  isFullWidth: false,
  accessibility: {
    title: null,
    'aria-label': null,
    'aria-labelledby': null,
  },
};

Tag.displayName = 'Tag';

export default Tag;
